import { useState, useEffect } from 'react';
import { Timer } from '@phosphor-icons/react';

export default function CountdownTimer({ announcedTime, validatedAt, status }) {
  const [timeLeft, setTimeLeft] = useState(null);
  const [colorClass, setColorClass] = useState('timer-green');

  useEffect(() => {
    if (!announcedTime || !['validee', 'en_route', 'en_cours'].includes(status)) {
      setTimeLeft(null);
      return;
    }

    const calculateTimeLeft = () => {
      const now = new Date();
      const target = new Date(announcedTime);
      const diff = target - now;
      
      const minutes = Math.floor(diff / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      if (diff <= 0) {
        const overdue = Math.abs(minutes);
        setColorClass('timer-red');
        return `-${overdue}:${String(Math.abs(seconds)).padStart(2, '0')}`;
      } else if (minutes <= 10) {
        setColorClass('timer-orange');
      } else {
        setColorClass('timer-green');
      }

      return `${minutes}:${String(seconds).padStart(2, '0')}`;
    };

    setTimeLeft(calculateTimeLeft());
    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 1000);

    return () => clearInterval(interval);
  }, [announcedTime, status]);

  if (!timeLeft) return null;

  return (
    <div className={`flex items-center gap-1.5 font-mono font-bold ${colorClass}`} data-testid="countdown-timer">
      <Timer size={18} weight="bold" />
      <span>{timeLeft}</span>
    </div>
  );
}
